import React from 'react';
import StatCard from '../../role-based-dashboard/components/StatCard';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardTab = ({ institutionInfo }) => {
  const metrics = [
    {
      title: 'Total Students',
      value: '2,450',
      change: '+125',
      changeType: 'positive',
      icon: 'Users',
      iconColor: 'var(--color-primary)',
      trend: 'up'
    },
    {
      title: 'Placement Rate',
      value: '87.5%',
      change: '+5.2%',
      changeType: 'positive',
      icon: 'TrendingUp',
      iconColor: 'var(--color-success)',
      trend: 'up'
    },
    {
      title: 'Active Partnerships',
      value: '156',
      change: '+12',
      changeType: 'positive',
      icon: 'Building2',
      iconColor: 'var(--color-accent)',
      trend: 'up'
    },
    {
      title: 'Avg. Package',
      value: '₹6.5L',
      change: '+₹0.8L',
      changeType: 'positive',
      icon: 'IndianRupee',
      iconColor: 'var(--color-warning)',
      trend: 'up'
    }
  ];

  const recentActivities = [
    {
      id: 1,
      type: 'placement',
      title: 'Campus Drive Completed',
      company: 'Tech Innovations Pvt Ltd',
      description: '45 students shortlisted for final rounds',
      time: '2 hours ago',
      icon: 'Briefcase',
      iconColor: 'var(--color-success)'
    },
    {
      id: 2,
      type: 'batch',
      title: 'New Batch Added',
      company: 'B.Tech CSE 2024-2028',
      description: '120 students enrolled',
      time: '5 hours ago',
      icon: 'UserPlus',
      iconColor: 'var(--color-primary)'
    },
    {
      id: 3,
      type: 'partnership',
      title: 'Partnership Agreement Signed',
      company: 'Global Solutions India',
      description: 'MoU for campus recruitment',
      time: '1 day ago',
      icon: 'Handshake',
      iconColor: 'var(--color-accent)'
    },
    {
      id: 4,
      type: 'training',
      title: 'Training Program Launched',
      company: 'Full Stack Development Bootcamp',
      description: '80 students enrolled',
      time: '2 days ago',
      icon: 'GraduationCap',
      iconColor: 'var(--color-secondary)'
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'Campus Drive - DataTech Solutions',
      date: '2026-02-10',
      time: '10:00 AM',
      location: 'Auditorium Block A',
      attendees: 150
    },
    {
      id: 2,
      title: 'Industry Expert Session',
      date: '2026-02-12',
      time: '2:00 PM',
      location: 'Conference Hall',
      attendees: 200
    },
    {
      id: 3,
      title: 'Placement Preparation Workshop',
      date: '2026-02-15',
      time: '11:00 AM',
      location: 'Training Center',
      attendees: 180
    }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <StatCard key={index} {...metric} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-background rounded-lg p-6 border border-border">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-heading font-semibold text-foreground">Recent Activities</h3>
            <Button variant="ghost" size="sm" iconName="ExternalLink">
              View All
            </Button>
          </div>
          <div className="space-y-4">
            {recentActivities?.map((activity) => (
              <div key={activity?.id} className="flex gap-3 p-3 rounded-lg hover:bg-muted/50 transition-smooth">
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${activity?.iconColor}15` }}
                >
                  <Icon name={activity?.icon} size={18} color={activity?.iconColor} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground line-clamp-1">{activity?.title}</h4>
                  <p className="text-sm text-muted-foreground line-clamp-1">{activity?.company}</p>
                  <p className="text-xs text-muted-foreground mt-1">{activity?.description}</p>
                  <span className="text-xs text-muted-foreground">{activity?.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-background rounded-lg p-6 border border-border">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-heading font-semibold text-foreground">Upcoming Events</h3>
            <Button variant="ghost" size="sm" iconName="Calendar">
              View Calendar
            </Button>
          </div>
          <div className="space-y-4">
            {upcomingEvents?.map((event) => (
              <div key={event?.id} className="p-4 rounded-lg border border-border hover:border-primary transition-smooth">
                <h4 className="text-sm font-medium text-foreground mb-2">{event?.title}</h4>
                <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} color="var(--color-muted-foreground)" />
                    <span>{new Date(event?.date)?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={12} color="var(--color-muted-foreground)" />
                    <span>{event?.time}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                    <span>{event?.location}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Users" size={12} color="var(--color-muted-foreground)" />
                    <span>{event?.attendees} attendees</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardTab;